import {ButtonDownload} from "../search-result-details/ButtonDownload";
import React from "react";
import {useSearchResultDetailsState,} from "../search-result-details/SearchResultDetailsContext";
import {Stack} from "@mui/material";
import {useObserveWindowResize} from "../app/useObserveWindowResize";
import Divider from "@mui/material/Divider";
import {ToggleFullscreenButton} from "./ToggleFullscreenButton";
import {EditButton} from "./EditButton";
import {ButtonShare} from "../share-model/ButtonShare";

/**
 * Component holding the buttons available to the bottom right, when the object view is in preview mode.
 * On small screens button labels are always hidden so icons fit comfortably.
 * @returns {JSX.Element}
 * @constructor
 */
export const BottomActionBar = ({smallScreen, t, shareCallback}) => {
    const {model} = useSearchResultDetailsState();
    const windowDimensions = useObserveWindowResize(null);

    // Show text labels only on wide desktop screens
    const showButtonLabel = !smallScreen && windowDimensions.width > 1400;

    return (
        <>
            <Divider/>
            <Stack
                spacing={smallScreen ? 0.5 : 1}
                direction="row"
                sx={{
                    justifyContent: "space-evenly",
                    alignItems: "center",
                    pt: smallScreen ? 0.5 : 1,
                    pb: smallScreen ? 0.5 : 0,
                }}>
                {!smallScreen && <ToggleFullscreenButton showButtonLabel={showButtonLabel}/>}
                <EditButton showButtonLabel={showButtonLabel}/>
                <ButtonDownload model={model} showLabel={showButtonLabel}/>
                <ButtonShare callback={shareCallback} showLabel={showButtonLabel}/>
            </Stack>
        </>
    );
};
